"use client";

import { useEffect } from "react";
import { recordAnalyticsEvent } from "@/app/actions/analytics";
import { getAnalyticsPlatform } from "@/lib/analytics/platform";
import { getAcquisitionAttribution } from "@/lib/analytics/session";

const ENTRY_RECORDED_KEY = "la_entry_recorded";

/** Records one privacy-safe entry event for each browser session. */
export function AcquisitionTracker() {
  useEffect(() => {
    const attribution = getAcquisitionAttribution();
    if (!attribution?.sessionId) return;

    try {
      if (window.sessionStorage.getItem(ENTRY_RECORDED_KEY)) return;
      window.sessionStorage.setItem(ENTRY_RECORDED_KEY, "1");
    } catch {
      // Continue without deduplication when storage is unavailable.
    }

    void recordAnalyticsEvent({
      eventType: "session_start",
      sessionId: attribution.sessionId,
      pageUrl: attribution.landingPath,
      referrer: attribution.referrerHost,
      metadata: {
        visitor_id: attribution.visitorId,
        source: attribution.source,
        medium: attribution.medium,
        campaign: attribution.campaign,
        term: attribution.term,
        content: attribution.content,
        landing_path: attribution.landingPath,
        referrer_host: attribution.referrerHost,
        first_source: attribution.firstSource,
        first_medium: attribution.firstMedium,
        first_campaign: attribution.firstCampaign,
        is_first_touch: attribution.isFirstTouch,
        platform: getAnalyticsPlatform(),
        is_handoff: attribution.isHandoff,
        handoff_from: attribution.handoffFrom,
        handoff_visitor_id: attribution.handoffVisitorId,
      },
    }).catch(() => {});
  }, []);

  return null;
}
